import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { useDownloadDocumentContent } from "@planzone/view-models";
import { DocumentIcon } from "@common/documentIcon";
import { Skeleton } from "@common/skeleton";
import { DocxRenderer } from "./docxRenderer";
import { DefaultRenderer } from "./defaultRenderer";
import { Props } from "./types";
import styles from "./styles.scss";

function isDocx(mimeType: string) {
  return [
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/msword",
  ].includes(mimeType);
}

function Preview({ document, selectedDocument }: Props) {
  const { t } = useTranslation();
  const {
    isRequestPending,
    isRequestSuccess,
    isRequestFailure,
    file,
    downloadDocumentContent,
  } = useDownloadDocumentContent(document);

  React.useEffect(() => {
    !isRequestPending &&
      !isRequestSuccess &&
      !isRequestFailure &&
      downloadDocumentContent({ document });
  }, [document.uri]);

  return (
    <div
      className={classNames(styles.preview, {
        [styles.selected]: document.uuid === selectedDocument.uuid,
      })}
    >
      <div className={styles.header}>
        <div className={styles.fileIcon}>
          <DocumentIcon mimeType={document.mimeType} />
        </div>
        <p className={styles.name}>
          {document.uuid === "1" ||
          document.uuid === "2" ||
          document.uuid === "3"
            ? t("documentCreation.templates.emptyDocument")
            : document.name}
        </p>
      </div>
      <div className={styles.templateBox}>
        {isRequestPending ? (
          <div className={styles.loader}>
            <Skeleton className={styles.skeleton} />
          </div>
        ) : isDocx(document.mimeType) ? (
          <DocxRenderer document={document} file={file} />
        ) : (
          <DefaultRenderer document={document} file={file} />
        )}
      </div>
    </div>
  );
}

export { Preview };
